import { Link } from "react-router-dom";
import { useScrollAnimation } from "../../../hooks/useScrollAnimation";

export default function CTASection() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section className="relative section-pad overflow-hidden bg-accent" ref={ref}>
      {/* Subtle texture elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full translate-x-48 -translate-y-24 pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-black/10 rounded-full -translate-x-24 translate-y-24 pointer-events-none" />

      <div
        className={`container-md relative z-10 text-center transition-all duration-700 ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <span className="inline-block text-white/70 text-xs font-semibold uppercase tracking-[0.2em] mb-5">
          Ready when you are
        </span>
        <h2 className="font-heading text-4xl md:text-6xl font-bold text-white leading-tight mb-6">
          Ready to grow your
          <br />
          business online?
        </h2>

        {/* Big price callout */}
        <div className="inline-flex items-center gap-6 bg-white/15 backdrop-blur-sm border border-white/25 rounded-2xl px-8 py-5 mb-8">
          <div className="text-left">
            <p className="text-white/70 text-xs uppercase tracking-widest mb-1">One simple price</p>
            <p className="font-heading text-5xl font-bold text-white leading-none">£149<span className="text-3xl">.00</span></p>
          </div>
          <div className="w-px h-14 bg-white/25" />
          <div className="text-left">
            <p className="text-white font-semibold text-base">Complete website</p>
            <p className="text-white/70 text-sm mt-0.5">Up to 5 pages — no hidden fees</p>
            <p className="text-white/70 text-sm">Mobile-friendly &amp; SEO-ready</p>
          </div>
        </div>

        <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-8">
          Join over <strong className="text-white">100 small business owners</strong> who have transformed their online presence — and their bottom line — with a professional website.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/contact"
            className="whitespace-nowrap inline-flex items-center justify-center gap-2 bg-white text-accent hover:bg-zinc-50 font-bold px-8 py-4 rounded-lg text-base transition-all duration-200 cursor-pointer shadow-xl shadow-black/20"
          >
            Get My Website — £149
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
          <Link
            to="/contact"
            className="whitespace-nowrap inline-flex items-center justify-center gap-2 border-2 border-white/50 hover:border-white text-white font-semibold px-8 py-4 rounded-lg text-base transition-all duration-200 cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-line" />
            </span>
            Talk to Us First
          </Link>
        </div>

        <p className="text-white/60 text-sm mt-6">
          No commitment. No hidden fees. Just a great website for £149.
        </p>
      </div>
    </section>
  );
}
